<template>
  <nav class="breadcrumbs">
    <ul class="list breadcrumbs_list">
      <li class="item">
        <NuxtLink
          :to="localePath('/')"
          aria-label="To home page"
        >
          <i class="g-csgo" />
          <span>{{ t('main') }}</span>
        </NuxtLink>
      </li>
      <li
        v-if="item?.weapon || item?.full_name || (item?.category && item?.category?.toLowerCase() !== 'collections')"
        :class="{ last: type === 'weapon' }"
        class="item"
      >
        <NuxtLink
          :to="localePath(`/weapons/${getModifiedString(item?.weapon || item?.full_name || item?.category)}`)"
          aria-label="To skins list page"
        >
          <span>{{ item?.weapon || item?.full_name || item?.category || '' }}</span>
        </NuxtLink>
      </li>
      <li
        v-if="type !== 'weapon'"
        class="item"
      >
        <NuxtLink
          :to="localePath(`/item/${route.params.name || route.params.id}`)"
          aria-label="To skin page"
        >
          {{ getMarketName(item?.market_hash_name || item?.full_name) }}
        </NuxtLink>
      </li>
      <li
        v-if="item.container"
        class="item"
      >
        <NuxtLink
          :to="getContainerLink({
            name: item?.market_hash_name || item?.full_name,
            category: item?.category,
            slug: item?.link,
          })"
          aria-label="To container page"
        >
          {{ t(getSkinsLabel(item?.market_hash_name || item?.full_name)) }}
          {{ t('View').toLowerCase() }}
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { getContainerLink, getModifiedString } from '~/utils/name-utils';

defineProps<{
  item: any
  // item: Item | ItemPageInfo | null
  type: string
}>();
const localePath = useLocalePath();
const { t } = useI18n();
const route = useRoute();

function getMarketName(name: string) {
  if (!name)
    return '';

  let marketName: string;
  if (name.includes('(') && name.includes('Graffiti ')) {
    marketName = name.substring(0, name.indexOf('(') - 1);
  } else {
    marketName = name;
  }
  return marketName;
}

function getSkinsLabel(hashName: string) {
  hashName = getModifiedString(hashName);
  let category: string;

  if (hashName.includes('souvenir')) {
    category = 'Skins';
  } else if (hashName.includes('autograph-capsule') || hashName.includes('sticker')) {
    category = 'Stickers';
  } else if (hashName.includes('collection-package')) {
    category = 'Crates';
  } else if (hashName.includes('graffiti')) {
    category = 'Graffities';
  } else if (hashName.includes('music-kit-box')) {
    category = 'Music Kits';
  } else if (hashName.includes('case')) {
    category = 'Skins';
  } else if (hashName.includes('pin')) {
    category = 'Pins';
  } else if (hashName.includes('patch')) {
    category = 'Patches';
  } else if (hashName.includes('collection')) {
    category = 'Collections';
  } else {
    category = 'Skins';
  }
  return category;
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  width: 100%;
  margin: 2rem 0;

  [class^="g-"],
  [class*=" g-"] {
    margin-left: 0.4rem;
  }

  &_list {
    display: inline-flex;
    align-items: center;

    .item {
      display: flex;
      align-items: center;
      color: var(--surfaces-on-surface);
      font-weight: 300;
      font-size: 1.4rem;
      line-height: 150%;

      a {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--surfaces-on-surface-variable);

        &:hover {
          color: var(--accent-on-accent-secondary);
        }
      }

      &:last-child a {
        color: var(--accent-on-accent-secondary);
        pointer-events: none;
      }

      &:after {
        // font-size: 1rem;
        font-size: 0.8rem;
        // margin: 0 0.5rem 0 0.8rem;
        // color: var(--surfaces-on-surface-variable);
        margin: 0 1rem;
        color: var(--surfaces-on-surface);
        content: "\e800";
        font-family: "fontello";
        font-style: normal;
        font-weight: normal;
        speak: never;
        transform: rotate(-90deg);
        display: flex;
        text-decoration: inherit;
        text-align: center;
        font-variant: normal;
        text-transform: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        opacity: 0.3;
      }

      &:last-child:after {
        display: none;
      }
    }

    .last {
      &:after {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    height: 4.2rem;
    margin: 0;
    overflow: hidden;
    &_list {
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      height: 4rem;
      padding-bottom: 0.5rem;
      // padding: 0 1rem 1rem;
      .item {
        display: flex;
        padding-top: 0.5rem;
        // &:first-child {
        //   padding-left: 1.6rem;
        // }
        // &:last-child {
        //   padding-right: 1.6rem;
        //   display: none;
        // }
      }
    }
  }

  @media screen and (max-width: 600px) {
    &_list {
      .item {
        display: none;

        &:nth-last-child(2) {
          display: flex;
          flex-direction: row-reverse;

          a {
            color: var(--surfaces-on-surface-variable);
            pointer-events: auto;

            &:hover {
              color: var(--accent-on-accent-secondary);
            }
          }

          &:after {
            color: var(--surfaces-on-surface-variable);
            opacity: 1;
            display: inline-block;
            transform: rotate(90deg);
          }
        }
      }
    }
  }
}
</style>
